export default __webpack_public_path__ + "80ce170f13dbbd37aeebf6c2b7a0f484.png";